import { defineMessages } from 'react-intl'

const messages = defineMessages({
  forgottenPassword: {
    id: 'auth.forgotten-password',
  },
  enterEmailSendLink: {
    id: 'auth.enter-email-send-link',
  },
  email: {
    id: 'global.email',
  },
  sendLink: {
    id: 'auth.send-link',
  },
  cancel: {
    id: 'global.cancel',
  },
  linkSent: {
    id: 'auth.link-sent',
  },
  accountExist: {
    id: 'global.account-exist',
  },
  forgotStep1: {
    id: 'forgot.step-1',
  },
  forgotStep2: {
    id: 'forgot.step-2',
  },
  forgotStep3: {
    id: 'forgot.step-3',
  },
  done: {
    id: 'global.done',
  },
})

export default messages
